import { gql } from '@apollo/client'

export const VERIFY_POTENTIAL_PAYEE = gql`
  mutation verifyPotentialPayee(
    $appName: AppNameEnum
    $verifyPotentialPayeeRequest: VerifyPotentialPayeeRequest
  ) {
    verifyPotentialPayee(
      appName: $appName
      verifyPotentialPayeeRequest: $verifyPotentialPayeeRequest
    ) {
      verifiedPayees {
        payeeId
        isAdditionalInfoRequired
        merchantData {
          billerLogoUrl
          billerName
          billerSiteUrl
        }
        verificationTokens {
          tokenDescription
          tokenType
          tokenValue
        }
        payeeAccountInfo {
          maskedaccountNumber
        }
        errorCode
        errorMessage
        __typename
      }
    }
  }
`
export default VERIFY_POTENTIAL_PAYEE
